import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import IPLPTemplateUpdate from './IPLPTemplateUpdate';
import { IplpTemplate } from '../../../../../graphql/graphql';

interface Props extends BaseModalProps {
	item: IplpTemplate;
	onUpdate: () => void;
}

const IPLPTemplateUpdateModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.IPLPTemplateUpdateModal.title'>
			<IPLPTemplateUpdate item={props.item} onUpdate={props.onUpdate} />
		</BaseModal>
	);
};

export default IPLPTemplateUpdateModal;
